import { createContext, useContext } from "react";
import type { Commute } from "@/types/domain";

export type MapSurfaceRect = {
  top: number;
  left: number;
  width: number;
  height: number;
};

export type PersistentCommuteMapScene = {
  commutes: Commute[];
  userLocation: { lat: number; lon: number } | null;
};

export type PersistentCommuteMapContextValue = {
  scene: PersistentCommuteMapScene;
  selectedCommuteId: string | null;
  surfaceRect: MapSurfaceRect | null;
  isActive: boolean;
  showRecenter: boolean;
  setShowRecenter: (show: boolean) => void;
  registerRecenterHandler: (handler: (() => void) | null) => void;
  recenterMap: () => void;
  setScene: (nextScene: PersistentCommuteMapScene) => void;
  setSelectedCommuteId: (commuteId: string | null) => void;
  setSurfaceRect: (rect: MapSurfaceRect | null) => void;
  setIsActive: (active: boolean) => void;
};

export const defaultScene: PersistentCommuteMapScene = {
  commutes: [],
  userLocation: null,
};

export const PersistentCommuteMapContext =
  createContext<PersistentCommuteMapContextValue | null>(null);

export function usePersistentCommuteMap() {
  const context = useContext(PersistentCommuteMapContext);
  if (!context) {
    throw new Error(
      "usePersistentCommuteMap must be used within PersistentCommuteMapProvider",
    );
  }
  return context;
}
